import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Button from 'components/Button';
import GridBlock from 'components/GridBlock';
import NationalNoticeStatus from "components/complex/nationalNotice/constants/NationalNoticeStatus";
import RouterPath from "libs/RouterPath";
import Typography from "components/Typography";
import useEzamowieniaOauth from "hooks/useEzamowieniaOauth";
import NationalNoticeService from "services/NationalNoticeService";
import WorkableButton from "components/button/WorkableButton";
import {isDemandModification, isDemandPreparing} from "libs/getDemandStatus";
import Loading from "components/Loading";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/styles";
import {MO_REQUIRED_GROUPS} from "constants/EzamowieniaRequiredGroups";

const style = theme => ({
    root: {},
    error: {
        color: theme.palette.common.error
    },
    minusMargin: {
        marginBottom: theme.spacing(-1),
        textAlign: "center"
    },
})

function BzpNoticeButtons(
    {
        classes,
        id,
        classesRoot,
        editable,
        setWorking,
        clearPublishResources,
        bzpContractNoticeStatus
    }) {
    const [ezWorking, setEzWorking] = useState(false);
    const {authorizeEzamowienia} = useEzamowieniaOauth();

    const goToNationalNotice = () => {
        const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_NATIONAL_NOTICE_FORM_TYPE_ID, {formType: "contractNotice", id});
        RouterPath.redirect(href);
    }

    const sendContractNotice = () => {
        setEzWorking(true);

        if (isDemandModification()) {
            authorizeEzamowienia(() => {
                NationalNoticeService.publishContractNoticeUpdate(id).catch((e) => console.error(e)).finally(() => {
                    setEzWorking(false);
                    NationalNoticeService.getContractModificationNoticeStatus(id);
                })
            }, () => {
                setEzWorking(false)
            }, MO_REQUIRED_GROUPS)
        } else {
            authorizeEzamowienia(() => {
                NationalNoticeService.publishContractNotice(id).catch((e) => console.error(e)).finally(() => {
                    setEzWorking(false);
                    NationalNoticeService.getContractNoticeStatus(id)
                })
            }, () => {
                setEzWorking(false)
            }, MO_REQUIRED_GROUPS)
        }
    }

    const rollbackContractNotice = () => {
        setEzWorking(true);
        if (isDemandModification()) {
            NationalNoticeService.rollbackContractNoticeUpdate(id).catch((e) => console.error(e)).finally(() => setEzWorking(false))
        } else {
            NationalNoticeService.rollbackContractNotice(id).catch((e) => console.error(e)).finally(() => setEzWorking(false))
        }
    }

    const checkContractNoticeStatus = () => {
        setEzWorking(true);
        authorizeEzamowienia(() => {
            NationalNoticeService.checkContractNoticeStatus(id).catch((e) => console.error(e)).finally(() => setEzWorking(false))
        }, () => {
            setEzWorking(false)
        }, MO_REQUIRED_GROUPS)
    }

    if(!bzpContractNoticeStatus ) return <Loading/>
    return (
        <GridBlock
            className={classesRoot}
            direction='column'
            alignItems='center'
        >
                <Typography variant='body1' align='center'>{Tr('ezamowienia_state_' + bzpContractNoticeStatus.status.toLowerCase())}</Typography>
                {
                    (bzpContractNoticeStatus.status === NationalNoticeStatus.DRAFT) && <>
                        <Button
                            onClick={goToNationalNotice}
                        >
                            {Tr('bzp_notice_create')}
                        </Button>
                    </>
                }
                {
                    bzpContractNoticeStatus.status === NationalNoticeStatus.COMPLETED && <>
                        <WorkableButton
                            onClick={sendContractNotice}
                            disabled={!editable || ezWorking}
                            working={ezWorking}
                        >
                            {Tr(isDemandPreparing() ? 'bzp_notice_publish' : 'bzp_notice_publish_update')}
                        </WorkableButton>
                    </>
                }
                {
                    bzpContractNoticeStatus.status === NationalNoticeStatus.SEND && <>
                        <WorkableButton
                            onClick={checkContractNoticeStatus}
                            disabled={!editable || ezWorking}
                            working={ezWorking}
                        >
                            {Tr('bzp_notice_status')}
                        </WorkableButton>
                    </>
                }
                {
                    (bzpContractNoticeStatus.status === NationalNoticeStatus.PUBLICATION_ERROR || bzpContractNoticeStatus.status === NationalNoticeStatus.INTEGRATION_ERROR) && <>
                        <WorkableButton
                            onClick={rollbackContractNotice}
                            disabled={!editable || ezWorking}
                            working={ezWorking}
                        >
                            {Tr('bzp_notice_rollback_' + bzpContractNoticeStatus.status.toLowerCase())}
                        </WorkableButton>
                    </>
                }

        </GridBlock>
    )
}

BzpNoticeButtons.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(BzpNoticeButtons);